// Actiondan gelen datalar ile stateler güncellenecek
export const LDAPLoading = (state, payload) => {
  state.loading = payload
}

export const ADAttributes = (state, payload) => {
  state.attributes = payload.data
}

export const LDAPStatus = (state, payload) => {
  state.status = payload
}

export const ADFilters = (state, payload) => {
  state.filters = payload.data
}

export const setLDAPData = (state, payload) => {
  state.LDAPData = payload.data ? payload.data.length > 0 ? payload.data : [] : []
}

export const LDAPFilterDetail = (state, payload) => {
  state.LDAPFilter = payload.data ? payload.data : {}
}

export const ADFields = (state, payload) => {
  state.ADFields = payload.data ? payload.data : {}
}




// WEBPACK FOOTER //
// ./src/store/modules/LDAP/Mutaions.js